/**
 * Component Name: PrivateRoute
 * Author: Ajo John
 * Description: Handles routes that require authentication.
 */

import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ path, children }) => {
  const isAuthGranted = true; // TODO: replace with real auth logic

  if (!isAuthGranted) {
    // redirect to login
    window.location.replace('https://accounts.lambdatest.com/login');
    return null;
  }

  if (path.includes('/')) {
    return <Navigate to="/hyperexecute" />;
  }

  return children; // render the actual protected component
};

export default PrivateRoute;
